//Please add the language resource
const toxinInspectResult = {
  purchOrderNo:'采购订单号',
  appointmentNo:'预约单号',
  toxinSampleNo:"毒素采样码",
  qcNo: "质检取样单号",
  sampleDateBegin:"开始毒素检测日期",
  sampleTimeBegin:"开始毒素检测时间",
  sampleTimeBeginOptUserNo:'开始毒素检测-操作人',
  sampleDateEnd:'结束毒素检测日期',
  sampleTimeEnd:'结束毒素检测时间',
  toxinExemptFlag:'是否免检',
  toxicResultsStr:'毒素结果',
  sampleTimeEndOptUserNo:'结束毒素检测-操作人',
  toxinInspectStatusName: '毒素检查状态',
  msg:{
  }
};
export default toxinInspectResult



// WEBPACK FOOTER //
// ./src/page/toxin/toxinInspectResult/lang/toxinInspectResult.en.js